import type { SelectBoxGuidEntityWithDefaultModel } from "@api/api";

export function resolveGrupoPorDefecto(grupos: SelectBoxGuidEntityWithDefaultModel[]): string | undefined {
  if (!grupos.length)
    return undefined;

  if (grupos.length === 1)
    return grupos[0].Id;

  const vigente = grupos.find(g => g.PorDefecto);
  if (vigente)
    return vigente.Id;

  return grupos[0].Id;
}
